export const PAYMENT_METHODS = 'payment-methods';
export const PAYMENT_METHOD = 'payment-method';

export const jpgSettings = ['h=70', 'q=90'];
